define('promise/main',[ "./es6-promise" ], function( lib ) {
	var Promise = window.Promise;

	// Detection code for DOM Promise implementation taken from the es6-promise module's own `polyfill()` method.
	// Said method isn't directly used because it would patch the polyfill Promise onto the global window object,
	// which we don't want. We just want to know when our package's main module should short-circuit and return
	// the native implementation instead of the library implementation.
	if ( Promise && !Promise.cast && "[object Promise]" === Object.prototype.toString.call( Promise.resolve())) {
		return Promise;
	};

	return lib.Promise;
});
define('promise', ['promise/main'], function (main) { return main; });

